module.exports = __webpack_public_path__ + "img/gpo_ips.1f48e6fc.png";